import { Typography } from '@mui/material';

import MaxWidthContainer from '../max-width-containe/max-width-container.component';

import { heading1 } from '../../../shared/theme/text.styles';

const PageLayout = ({ heading, hideHeading, children }) => {
  return (
    <MaxWidthContainer>
      {
        <Typography
          variant='h1'
          gutterBottom
          sx={{
            ...heading1,
            marginTop: '80px',
            '@media (max-width: 1024px)': {
              textAlign: 'center',
              marginTop: '30px',
            },
          }}
        >
          {!hideHeading && heading}
        </Typography>
      }
      {children}
    </MaxWidthContainer>
  );
};

export default PageLayout;
